import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import CategoriesPage from "./pages/CategoriesPage";
import BusinessDetailPage from "./pages/BusinessDetailPage";
import SearchPage from "./pages/SearchPage";
import AuthPage from "./pages/AuthPage";
import AddShopPage from "./pages/AddShopPage";
import DashboardPage from "./pages/DashboardPage";
import AdminPage from "./pages/AdminPage";
import AboutUsPage from "./pages/AboutUsPage";
import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="App min-h-screen flex flex-col">
              <Routes>
                {/* Pages without header/footer */}
                <Route path="/login" element={<AuthPage />} />
                <Route path="/register" element={<AuthPage />} />
              
              {/* Pages with header/footer */}
              <Route
                path="/*"
                element={
                  <>
                    <Header />
                    <main className="flex-1">
                      <Routes>
                        <Route index element={<HomePage />} />
                        <Route path="categories" element={<CategoriesPage />} />
                        <Route path="category/:categoryId" element={<CategoryPage />} />
                        <Route path="business/:businessId" element={<BusinessDetailPage />} />
                        <Route path="search" element={<SearchPage />} />
                        <Route path="add-shop" element={<AddShopPage />} />
                        <Route path="dashboard" element={<DashboardPage />} />
                        <Route path="admin" element={<AdminPage />} />
                        <Route path="about" element={<AboutUsPage />} />
                      </Routes>
                    </main>
                    <Footer />
                  </>
                }
              />
            </Routes>
            <Toaster position="top-right" richColors />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
